import queries from '@apis/queries';
import useOnPushMessageReceived from '@hooks/native/useOnPushMessageReceived';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@stackflow/react';
import { useQueryClient } from '@tanstack/react-query';
import { openExternalLink } from '@utils/nativeUtils';
import { useTranslation } from 'react-i18next';

function usePushMessage() {
    const { push } = useFlow();
    const queryClient = useQueryClient();
    const toast = useToast();
    const { t } = useTranslation('main', { keyPrefix: 'toast' });
    // 푸시 메시지 수신 리스너
    useOnPushMessageReceived({
        onPushMessageReceived: (data) => {
            queryClient.invalidateQueries({ queryKey: queries.user._def });
            queryClient.invalidateQueries({ queryKey: queries.notifications._def });
            queryClient.invalidateQueries({ queryKey: queries.orders._def });
            queryClient.invalidateQueries({ queryKey: queries.coupons._def });
            queryClient.invalidateQueries({ queryKey: queries.stamps._def });
            queryClient.invalidateQueries({ queryKey: queries.orderLog._def });

            const { pushType, pushArg, appState } = data;
            if (appState === 'BACKGROUND') {
                switch (pushType) {
                case 'NOTICE':
                    if (pushArg) {
                        push('NoticeActivity', { noticeId: pushArg });
                    }
                    return;
                case 'EVENT':
                    if (pushArg) {
                        push('EventActivity', { eventId: pushArg });
                    }
                    return;
                case 'COUPON':
                    push('CouponActivity', { type: 'DOWNLOAD' });
                    break;
                case 'URL':
                    if (pushArg) {
                        openExternalLink(pushArg);
                    }
                    break;
                default:
                    break;
                }
            } else {
                toast.info(t('newNotification'));
            }
        },
        deps: [t],
    });
}

export default usePushMessage;
